import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {PlatformTable} from "../PlatformTable";

class ProjectMilestoneSessionTable extends PlatformTable {
}

export default withNavigate(withAppContext(withBreakpoint(ProjectMilestoneSessionTable)));